import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateClientContactActions } from "store/ducks/settings/client-contact";

export function* paginateClientContactRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/client-contact?${queryString}`
    );

    const { clientContact, pagination } = responseBody;
    yield put(PaginateClientContactActions.success(clientContact, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateClientContactActions.failure(errorMessage));
  }
}
